
import { apiFetch } from './client';
import type { DashboardLayout } from '../types/contracts';

export const dashboardApi = {
  getLayout: ()                        => apiFetch<DashboardLayout>('/api/dashboard/layout'),
  putLayout: (layout: DashboardLayout) => apiFetch<DashboardLayout>('/api/dashboard/layout',
    { method: 'PUT', body: JSON.stringify(layout) }),
};
